import type { ComponentType } from "react";

/** 菜单 href → 动态 import 工厂 */
export type PageLoader = () => Promise<{ default: ComponentType }>;

/** 菜单叶子 href 与页面对应关系；新增页面时只改此表 */
export const PAGE_LOADERS: Record<string, PageLoader> = {
  "/dashboard": () => import("@/pages/Dashboard").then((m) => ({ default: m.DashboardPage })),
  "/accounts": () => import("@/pages/Accounts"),
  "/entities": () => import("@/pages/EntitiesPage"),
  "/agents": () => import("@/pages/Agents"),
  "/chains": () => import("@/pages/Chains"),
  "/stores": () => import("@/pages/Stores"),
  "/employees": () => import("@/pages/Employees"),
  "/members": () => import("@/pages/Members"),
  "/settings/admin-regions": () => import("@/pages/Settings/AdminRegions"),
  "/settings/app-mapping": () => import("@/pages/Settings/AppMapping"),
  "/settings/dictionaries": () => import("@/pages/Settings/Dictionaries"),
  "/settings/menus": () => import("@/pages/Settings/Menus"),
  "/settings/tags": () => import("@/pages/Settings/Tags"),
  "/settings/roles": () => import("@/pages/Settings/Roles"),
  "/settings/organizations": () => import("@/pages/Settings/Organizations"),
  "/settings/sku": () => import("@/pages/Settings/Sku"),
  "/settings/infrared-code": () => import("@/pages/Settings/InfraredCode"),
};

/**
 * 从页面注册表推导需动态重定向的父级菜单路径
 * 如 /settings/tags → 父级 /settings
 */
export const getParentMenuHrefs = (): string[] => {
  const parents = new Set<string>();
  for (const href of Object.keys(PAGE_LOADERS)) {
    const segments = href.split("/").filter(Boolean);
    if (segments.length > 1) {
      parents.add(`/${segments[0]}`);
    }
  }
  return [...parents];
};
